import React, { Component, Fragment } from 'react';
import Arrow from '../../../../assets/images/arrow-down-dark@3x.png';
import { getToken } from '../../../../selectors/authSelectors';
import { select } from '../../../../stores';
import { getValidToken, isApp } from '../../../../utils';
import {
  getGaPagePath,
  handleGaError,
  trackScrollDepth,
  TrackScrollDepthDirection,
} from '../../../../utils/generalGaEventAnalytics';
import { horizontalHandler } from '@axa-asia/hk-emma-web-module/lib/ga-lib/GaScrollDepthListener';

export interface DropdownProps {
  onClickModuleCard: (cardId: string) => void;
  context: {
    title?: string;
    empty: {
      tip?: string;
      tipIcon?: string;
      value: Array<string>;
    };
    option: Array<{
      value: string;
      item: string;
      default: boolean;
    }>;
    resultTitle?: string;
    optionResults?: Array<{
      icon: string;
      title: string;
      desc: string;
      value: Array<string>;
    }>;
  };
}

export interface DropdownStates {
  title?: string;
  empty: {
    tip?: string;
    tipIcon?: string;
    value: Array<string>;
  };
  option: Array<{
    value: string;
    item: string;
    default: boolean;
  }>;
  resultTitle?: string;
  optionResults?: Array<{
    icon: string;
    title: string;
    desc: string;
    value: Array<string>;
  }>;
  curSelectedValue?: string;
  curSelectedCode?: string;
}

export class Dropdown extends Component<DropdownProps, DropdownStates> {
  ref: any;

  constructor(props: any = {}) {
    super(props);
    this.state = this.props.context;
    this.ref = React.createRef();
    this.isExist = this.isExist.bind(this);
    this.showDiseasePrevention = this.showDiseasePrevention.bind(this);
    this.onPopupCardModal = this.onPopupCardModal.bind(this);
    // this.valueChange = this.valueChange.bind(this);
    this.onClickToGatc = this.onClickToGatc.bind(this);
  }

  componentDidMount() {
    if (this.state && this.state.option && this.state.option.length > 0) {
      const StateObj = JSON.parse(JSON.stringify(this.state));
      const defaultDropdownValue = this.state.option.find((o) => o.default);
      StateObj.curSelectedCode = defaultDropdownValue
        ? defaultDropdownValue.value
        : this.state.option[0].value;
      StateObj.curSelectedValue = defaultDropdownValue
        ? defaultDropdownValue.item
        : this.state.option[0].item;
      this.setState(() => StateObj);
      this.valueChange(undefined, StateObj.curSelectedCode);
    }
  }

  valueChange(event?: any, selectedValue?: any) {
    if (!selectedValue && event && event.target && event.target.value) {
      selectedValue = event.target.value;
    }
    const StateObj = JSON.parse(JSON.stringify(this.state));
    StateObj.optionResults = JSON.parse(
      JSON.stringify(this.props.context.optionResults),
    );
    StateObj.curSelectedCode = selectedValue;
    if (this.state) {
      this.state.option.forEach(
        (
          item: {
            value: string;
            item: string;
            default: boolean;
          },
          index: number,
        ) => {
          if (selectedValue === item.value) {
            StateObj.curSelectedValue = item.item;
          }
        },
      );
    }
    StateObj.optionResults = StateObj.optionResults.filter((item: any) => {
      return this.isExist(item.value, StateObj.curSelectedCode);
    });
    this.setState(() => StateObj);
  }

  isExist(arr: Array<any>, value = '') {
    return arr.includes(value);
  }

  showDiseasePrevention() {
    if (
      this.state &&
      this.state.option.length > 0 &&
      this.state.optionResults
    ) {
      const StateObj = JSON.parse(JSON.stringify(this.state));
      StateObj.optionResults = StateObj.optionResults.filter((item: any) => {
        return this.isExist(item.value, StateObj.curSelectedCode);
      });
      this.setState(() => StateObj);
    }
  }

  onPopupCardModal(cardId: string) {
    this.props.onClickModuleCard(cardId);
  }

  onClickToGatc(item: any) {
    const serviceOverlay = item ? item.title : '';
    const tcWindow: any = window;
    try {
      const token = select(getToken);
      const aToken = getValidToken(token);
      tcWindow.dataLayer.push({
        event: 'Critical Illness Value-Added-Services',
        serviceOverlay: serviceOverlay,
        screenName: getGaPagePath(),
        userId: aToken,
      });

      // HKEMMA-100917 - GA3 Decommission - Remove GA3
      // if (!isApp()) {
      //   tcWindow.tC.event.criticalIllness(this, {
      //     serviceOverlay: serviceOverlay,
      //     screenName: getGaPagePath(),
      //   });
      // }
    } catch (e) {
      handleGaError(e);
    }
  }

  handleHorizontalScroll = horizontalHandler((ratio: number) => {
    const screenName: string = getGaPagePath();
    console.log(ratio);
    trackScrollDepth(ratio, TrackScrollDepthDirection.HORIZONTAL, screenName);
  });

  render():
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | string
    | number
    | {}
    | React.ReactNodeArray
    | React.ReactPortal
    | boolean
    | null
    | undefined {
    return (
      <div className="my-privileges-details-view__form_wrap">
        {this.state && this.state.option && this.state.option.length > 0 && (
          <Fragment>
            {this.state.title && (
              <div className="title">{this.state.title}</div>
            )}
            <div className="select">
              <div>{this.state.curSelectedValue}</div>
              <img src={Arrow} alt="" />
            </div>
            <select
              value={this.state.curSelectedCode}
              onChange={(e) => {
                this.valueChange(e);
              }}
            >
              {this.state.option.map((item: any, index: number) => {
                return (
                  <option key={index} value={item.value}>
                    {item.item}
                  </option>
                );
              })}
            </select>
            {this.isExist(
              this.state.empty.value,
              this.state.curSelectedCode,
            ) && (
              <div className="my-privileges-details-view__form_wrap_no_suitable">
                {this.state.empty.tipIcon && (
                  <img src={this.state.empty.tipIcon} alt="" />
                )}
                {this.state.empty.tip && <div>{this.state.empty.tip}</div>}
              </div>
            )}
          </Fragment>
        )}

        {this.state &&
          this.state.optionResults &&
          this.state.optionResults.length > 0 && (
            <div className="my-privileges-details-view__disease">
              {this.state.resultTitle && <div>{this.state.resultTitle}</div>}
              {this.state.optionResults && (
                <div
                  className="my-privileges-details-view__disease_slider_wrap"
                  onScroll={this.handleHorizontalScroll}
                >
                  {this.state.optionResults.map((item: any, index: number) => {
                    return (
                      <div
                        className="my-privileges-details-view__disease_slider_wrap_item"
                        key={index}
                        data-enable-ga
                        data-ga-type="button"
                        onClick={() => {
                          this.onClickToGatc(item);
                          this.onPopupCardModal(item.id);
                        }}
                      >
                        <div className="my-privileges-details-view__disease_slider_wrap_item_card_view_container">
                          <div className="my-privileges-details-view__disease_slider_wrap_item_card_view">
                            <div>
                              <img src={item.icon} />
                            </div>
                            <div>{item.title}</div>
                            <div>{item.desc}</div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
      </div>
    );
  }
}
